import MemberProfileCard from './MemberProfileCard';
export default MemberProfileCard;
